import styled from '@emotion/styled';
import { colors, sizes } from '@smartsheet/lodestar-core';

export const PanelButton = styled.div`
  height: 28px;
  width: 28px;
  border-radius: ${sizes.xxSmall}px;
  cursor: pointer;
  background: ${(props: { active?: boolean }) =>
    props.active ? colors.neutralLight30 : 'none'};
  &:hover {
    background: ${colors.neutralLight30};
  }
  span {
    margin-top: 2px;
    margin-left: 2px;
  }
`;
